import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'

interface Props {
  isEdit: boolean
  onSubmit: () => Promise<void>
}
export const AllocationRuleTemplateFormHeader = observer(({ isEdit, onSubmit }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action = isEdit
    ? t('editAllocationRuleTemplate', 'Edit allocation rule template')
    : t('addNewAllocationRuleTemplate', 'Add new allocation rule template')

  const breadCrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: t('allocationRulesTemplates', 'Allocation Rules Templates'),
      route: PATHS.masterData.allocationRuleTemplates.url,
    },
    { label: action },
  ]

  return (
    <Header
      title={action}
      breadcrumbs={breadCrumbs}
      position='relative'
      rightRenderOption={
        <>
          <Button
            variant='text'
            color='inherit'
            data-cy='cancel-allocation-rule-template-btn'
            onClick={() => navigate(PATHS.masterData.allocationRuleTemplates.url)}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => onSubmit()}
            data-cy='allocation-rule-template-save-btn'
          >
            {t('submit', 'Submit')}
          </Button>
        </>
      }
    />
  )
})
